import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  tableHeader: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& .gridRow': {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 0.8fr 44px',
      gap: '16px',
      alignItems: 'center',
      marginBottom: '24px',
    },
    '& .gridHeader': {
      paddingBottom: '16px',
      borderBottom: '1px solid rgba(30, 30, 30, 0.10)',
      margin: '0',
    },
    '& .label': {
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '20px',
      margin: '0',
    },
  },
  rows: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: '16px',
    '& .actions': { display: 'flex', justifyContent: 'center' },
    '& .iconBtn': {
      width: '26px',
      height: '26px',
      borderRadius: '50%',
      border: 'none',
      background: 'transparent',
      color: '#0f172a',
      cursor: 'pointer',
      transition: 'background-color .15s ease, transform .05s ease',
    },
  },
  col: {
    position: 'relative',
    '&.role': {
      minWidth: '180px',
      maxWidth: '180px',
    },
  },
  input: {
    minWidth: '376px',
  },
  stepOne: {
    padding: '24px 0',
  },
  stepOneWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  stepHeader: {
    color: '#1E1E1E',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: '20px',
  },
  stepHeaderDescription: {
    color: '#1E1E1E',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '20px',
    '& .for-user': {
      fontWeight: '700',
    },
  },
  stepContent: {
    display: 'flex',
    gap: '16px',
  },
  stepTwoContent: {
    display: 'flex',
    gap: '16px',
    '& .contentActions': {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      maxWidth: '376px',
      '& .actions': {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        marginBottom: '24px',
      },
      '& .buttons': {
        display: 'flex',
        gap: '16px',
        '& button': {
          borderRadius: '8px',
          border: '1px solid #1E1E1E',
          padding: '8px',
          color: '#1E1E1E',
          height: '32px',
          width: '100%',
        },
        '& .selected-count': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '32px',
          width: '100%',
          padding: '12px 16px',
          borderRadius: '100px',
        },
        '& .selected': {
          background: 'rgba(108, 89, 230, 0.05)',
          color: '#6C59E6',
        },
        '& .not-selected': {
          background: 'rgba(30, 30, 30, 0.10)',
          color: '#1E1E1E',
        },
      },
    },
    '& .wrapper': {
      marginBottom: '12px',
      '& .not-selected': {
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '20px',
        color: '#1E1E1E',
        opacity: '.6',
        padding: '12px 0',
      },
    },
    '& .wrapper .header': {
      fontSize: '16px',
      fontWeight: '500',
      lineHeight: '20px',
      paddingBottom: '8px',
    },
    '& .contentProjects': {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gridAutoRows: 'max-content',
      gap: '12px',
      maxHeight: 'calc(8 * 68px + 7 * 12px)',
      overflowY: 'auto',
      boxSizing: 'border-box',
    },
  },
  stepTwo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    padding: '24px 0',
  },
  developers: {
    display: 'flex',
    flexFlow: 'wrap',
    gap: '16px',
    padding: '20px 0 20px 0',
  },
  buttonsWrapper: {
    width: '100%',
    height: '100%',
    paddingTop: '16px',
    marginBottom: '24px',
    '& .divider': {
      width: '100%',
      borderBottom: '1px solid rgba(30, 30, 30, 0.10)',
    },
    '& .footer': {
      display: 'flex',
      justifyContent: 'space-between',
      paddingTop: '16px',
      '& .text': {
        color: '#1e1e1e',
        opacity: '.6',
        fontSize: '16px',
        fontWeight: '500',
        lineHeight: '20px',
        width: '376px',
      },
      '& .btn.disabled button': {
        backgroundColor: 'rgba(30, 30, 30, 0.20)',
      },
      '& button': {
        width: '376px',
        borderRadius: '4px',
        backgroundColor: '#1E1E1E',
        color: 'white',
        cursor: 'pointer',
      },
    },
  },
  errorText: {
    position: 'absolute',
    color: '#ED1C24',
  },
}));
